// Terms of Service content - California-compliant legal terms
export const TERMS_CONTENT = {
  hero: {
    title: 'Terms of Service',
    subtitle: 'Last Updated: October 22, 2025',
    effectiveDate: 'Effective Date: October 22, 2025'
  },

  sections: [
    {
      title: '1. Acceptance of Terms',
      content: [
        'By accessing or using the HammerSawPaint ("HSP," "we," "our," or "us") website, mobile application, or services, you ("Customer," "you," or "your") agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, you may not use our services.',
        'These Terms constitute a legally binding agreement between you and HammerSawPaint. We reserve the right to modify these Terms at any time. Your continued use of our services after changes are posted constitutes acceptance of the modified Terms.'
      ]
    },
    {
      title: '2. Description of Services',
      content: [
        'HammerSawPaint operates as a coordination platform that connects customers with independent, vetted home service professionals (referred to as "Subcontractors," "Service Providers," or "Independent Contractors").',
        'HSP DOES NOT directly provide home maintenance, repair, or improvement services. We facilitate the relationship between customers and independent service providers by:',
        '• Coordinating scheduling and service appointments',
        '• Processing payments on behalf of Subcontractors',
        '• Providing customer support and quality assurance oversight',
        '• Managing subscription memberships and service plans',
        '• Maintaining a network of vetted, independent service professionals',
        'All physical work is performed by independent contractors who are solely responsible for their work quality, safety, and compliance with applicable laws.'
      ]
    },
    {
      title: '3. Platform Role and Liability Limitation',
      content: [
        'IMPORTANT: HammerSawPaint is a technology platform and coordination service, NOT a direct service provider or contractor.',
        '3.1 Independent Contractor Relationship',
        'Each service is performed by an independent contractor who:',
        '• Maintains their own business licenses and permits',
        '• Carries their own general liability insurance',
        '• Is solely responsible for their work quality and safety',
        '• Sets their own methods and means of performing work',
        '• Is not an employee, agent, or partner of HammerSawPaint',
        '3.2 Liability Attribution',
        'LIABILITY FOR ALL WORK PERFORMED RESTS WITH THE INDEPENDENT SUBCONTRACTOR, NOT HAMMERSAWPAINT. By using our platform, you acknowledge and agree that:',
        '• HSP does not perform services or employ service workers',
        '• HSP does not carry liability insurance for services performed',
        '• Each Subcontractor is responsible for their own actions, negligence, and work quality',
        '• Claims related to work performed must be directed to the Subcontractor who performed the work',
        '• HSP\'s role is limited to coordination, payment processing, and quality oversight'
      ]
    },
    {
      title: '4. California Licensing Compliance',
      content: [
        'HammerSawPaint complies with all California Contractors State License Board (CSLB) regulations and California Business and Professions Code requirements.',
        '4.1 Licensing Requirements (California Business and Professions Code Section 7048)',
        '• Work under $500 (combined labor and materials per project) may be performed by unlicensed handymen',
        '• Projects exceeding $500 must be performed by appropriately licensed contractors',
        '• HSP verifies that each service provider maintains necessary licenses for their scope of work',
        '4.2 License Verification',
        'You may verify any contractor\'s license status at www.cslb.ca.gov or by calling (800) 321-CSLB (2752).',
        '4.3 Compliance Commitment',
        'HSP ensures all service providers comply with applicable licensing requirements and will only dispatch appropriately licensed professionals for work exceeding statutory limits.'
      ]
    },
    {
      title: '5. Membership Subscriptions',
      content: [
        '5.1 Subscription Plans',
        'HSP offers monthly membership subscriptions for ongoing home maintenance coordination services. Membership tiers include varying levels of service coordination, scheduling priority, and discounts.',
        '5.2 Billing and Payment',
        '• Membership fees are billed monthly on a recurring basis',
        '• Payment is due on the same date each month as your signup date',
        '• You authorize HSP to charge your payment method on file',
        '• Failed payments may result in service suspension',
        '• Prices are subject to change with 30 days notice',
        '5.3 Cancellation Policy',
        '• You may cancel your membership at any time without penalty or fees',
        '• Cancellations can be processed through your customer portal or by contacting support',
        '• Upon cancellation, you retain access through the end of your current billing period',
        '• No refunds are provided for partial months',
        '• Scheduled services will be completed through your cancellation date',
        '5.4 Modifications',
        '• You may upgrade or downgrade your membership plan at any time',
        '• Changes take effect at the next billing cycle',
        '• No prorated refunds for downgrades'
      ]
    },
    {
      title: '6. Service Quality and Satisfaction Guarantee',
      content: [
        '6.1 Quality Assurance',
        'While HSP does not perform services directly, we maintain quality standards through:',
        '• Vetting and background checking all service providers',
        '• Collecting customer feedback after each service',
        '• Monitoring service provider performance',
        '• Addressing quality concerns promptly',
        '• Removing underperforming providers from our network',
        '6.2 Satisfaction Guarantee',
        'If you are not satisfied with services coordinated through our platform:',
        '• Contact us within 48 hours of service completion',
        '• We will work with the service provider to address your concerns',
        '• The service provider may return to re-perform work at no additional charge',
        '• This guarantee applies to work quality, not subjective preferences',
        '6.3 Limitation of Guarantee',
        'Our satisfaction guarantee is limited to coordinating with the service provider. HSP is not responsible for:',
        '• Defects in workmanship (contractor responsibility)',
        '• Property damage caused by service provider (covered by their insurance)',
        '• Delays due to weather, permits, or circumstances beyond our control',
        '• Pre-existing conditions or hidden defects discovered during service'
      ]
    },
    {
      title: '7. Insurance and Risk of Loss',
      content: [
        '7.1 Subcontractor Insurance',
        'All service providers in our network are required to maintain:',
        '• Current general liability insurance',
        '• Workers\' compensation insurance (if applicable)',
        '• Any other insurance required by California law',
        'HSP verifies and maintains proof of insurance for all active subcontractors.',
        '7.2 HammerSawPaint Insurance',
        'HSP maintains errors and omissions (E&O) insurance for our platform operations but DOES NOT carry liability insurance for services performed by independent contractors.',
        '7.3 Claims Process',
        'In the event of property damage or injury:',
        '• Immediately contact the service provider and HSP',
        '• Document the issue with photos and written description',
        '• File a claim with the service provider\'s insurance carrier',
        '• HSP will provide insurance information and assist with coordination',
        '• Legal liability remains with the service provider, not HSP'
      ]
    },
    {
      title: '8. Customer Responsibilities',
      content: [
        'You agree to:',
        '• Provide accurate property information and access details',
        '• Ensure safe working conditions for service providers',
        '• Inform us of any hazards, pets, or special circumstances',
        '• Be available or provide access for scheduled services',
        '• Provide at least 24 hours notice for cancellations or rescheduling',
        '• Pay all fees and charges in a timely manner',
        '• Treat service providers with respect and professionalism',
        '• Communicate concerns or issues promptly',
        '• Maintain accurate contact and billing information',
        '• Review and approve service estimates for add-on work'
      ]
    },
    {
      title: '9. Prohibited Uses',
      content: [
        'You may not:',
        '• Use our platform for illegal purposes',
        '• Attempt to directly hire or solicit our service providers (see Non-Circumvention below)',
        '• Provide false or misleading information',
        '• Abuse, harass, or threaten service providers',
        '• Interfere with platform operations or security',
        '• Reverse engineer or copy our technology',
        '• Submit fraudulent payment information',
        '• Use the service for commercial resale purposes',
        '• Violate any applicable laws or regulations'
      ]
    },
    {
      title: '10. Non-Circumvention Clause',
      content: [
        'You agree not to directly hire, contract with, or solicit any service provider introduced to you through the HSP platform for a period of 12 months following your last service through HSP.',
        'This non-circumvention clause protects our business model and the relationships we\'ve built with service providers. Violations may result in:',
        '• Immediate termination of your account',
        '• Legal action to recover damages',
        '• Payment of liquidated damages equal to 12 months of your membership fees',
        'This does not prohibit hiring providers you knew independently before using HSP.'
      ]
    },
    {
      title: '11. Disclaimer of Warranties',
      content: [
        'TO THE MAXIMUM EXTENT PERMITTED BY CALIFORNIA LAW:',
        '11.1 Platform Services',
        'THE HSP PLATFORM AND COORDINATION SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED.',
        '11.2 No Warranty of Service Provider Performance',
        'HSP DOES NOT WARRANT OR GUARANTEE:',
        '• The quality, safety, or legality of services performed by independent contractors',
        '• That service providers will meet your expectations',
        '• That services will be error-free or uninterrupted',
        '• That defects will be corrected',
        '• That the platform will be secure or virus-free',
        '11.3 California Consumer Rights',
        'Some jurisdictions do not allow disclaimer of implied warranties. California consumers may have additional rights under the Song-Beverly Consumer Warranty Act.'
      ]
    },
    {
      title: '12. Limitation of Liability',
      content: [
        'TO THE MAXIMUM EXTENT PERMITTED BY CALIFORNIA LAW:',
        '12.1 Liability Cap',
        'HSP\'S TOTAL LIABILITY TO YOU FOR ALL CLAIMS ARISING FROM OR RELATED TO THESE TERMS OR OUR SERVICES SHALL NOT EXCEED THE AMOUNT YOU PAID TO HSP IN THE 12 MONTHS PRECEDING THE CLAIM.',
        '12.2 Excluded Damages',
        'HSP SHALL NOT BE LIABLE FOR:',
        '• Indirect, incidental, special, consequential, or punitive damages',
        '• Loss of profits, revenue, data, or business opportunities',
        '• Property damage caused by service providers (covered by their insurance)',
        '• Personal injury caused by service providers (covered by their insurance)',
        '• Work quality issues (service provider responsibility)',
        '12.3 Third-Party Actions',
        'HSP is not responsible for the acts, errors, omissions, representations, warranties, breaches, or negligence of any independent service provider.'
      ]
    },
    {
      title: '13. Indemnification',
      content: [
        'You agree to indemnify, defend, and hold harmless HammerSawPaint, its officers, directors, employees, and agents from any claims, damages, losses, liabilities, and expenses (including attorneys\' fees) arising from:',
        '• Your use of our platform or services',
        '• Your violation of these Terms',
        '• Your violation of any rights of another party',
        '• False or misleading information you provide',
        '• Your interactions with service providers',
        '• Property damage or injury caused by your negligence',
        'This indemnification survives termination of your account and these Terms.'
      ]
    },
    {
      title: '14. California Consumer Rights',
      content: [
        'As a California consumer, you have specific rights under state law:',
        '14.1 Complaint Process (California Civil Code Section 1789.3)',
        'If you have a complaint, you may contact:',
        'HammerSawPaint Customer Support',
        'Email: support@hsppro.com',
        'Phone: (888) 504-6944',
        'You may also contact:',
        'Complaint Assistance Unit',
        'Division of Consumer Services',
        'California Department of Consumer Affairs',
        '1625 North Market Blvd., Suite N 112',
        'Sacramento, CA 95834',
        'Phone: (800) 952-5210',
        'Website: www.dca.ca.gov',
        '14.2 Contractor Rights (California Business and Professions Code Section 7071.5)',
        'You have the right to:',
        '• Verify contractor licenses at www.cslb.ca.gov',
        '• Request proof of insurance from service providers',
        '• File complaints with CSLB regarding licensed contractors',
        '• Receive written contracts for work over $500'
      ]
    },
    {
      title: '15. Dispute Resolution',
      content: [
        '15.1 Informal Resolution',
        'Before filing any formal claim, you agree to first contact HSP to attempt informal resolution. Many disputes can be resolved quickly through communication.',
        '15.2 Binding Arbitration',
        'Any dispute arising from these Terms or our services shall be resolved through binding arbitration in accordance with the rules of JAMS (Judicial Arbitration and Mediation Services).',
        '15.3 Arbitration Terms',
        '• Arbitration will take place in San Francisco County, California',
        '• Each party bears their own costs and attorneys\' fees',
        '• The arbitrator\'s decision is final and binding',
        '• You waive the right to a jury trial',
        '• You waive the right to participate in class action lawsuits',
        '15.4 Exceptions',
        'Small claims court and injunctive relief are excepted from arbitration requirements.',
        '15.5 California Arbitration Rights',
        'California consumers may opt out of arbitration by sending written notice to support@hsppro.com within 30 days of account creation.'
      ]
    },
    {
      title: '16. Privacy and Data Use',
      content: [
        'Your privacy is important to us. Our collection, use, and sharing of your personal information is governed by our Privacy Policy, which is incorporated into these Terms by reference.',
        'Key points:',
        '• We collect information necessary to coordinate services',
        '• We share your information with service providers only as needed to book and perform services',
        '• We comply with California Consumer Privacy Act (CCPA)',
        '• You have rights to access, delete, and control your data',
        'Please review our complete Privacy Policy at www.hsppro.com/privacy-policy'
      ]
    },
    {
      title: '17. Termination',
      content: [
        '17.1 Your Right to Terminate',
        'You may cancel your account at any time as described in Section 5.3 (Cancellation Policy).',
        '17.2 Our Right to Terminate',
        'We may suspend or terminate your account immediately if you:',
        '• Violate these Terms',
        '• Fail to pay required fees',
        '• Abuse or harass service providers',
        '• Engage in fraudulent activity',
        '• Pose a safety risk',
        '17.3 Effect of Termination',
        'Upon termination:',
        '• Your right to use the platform ends immediately',
        '• Scheduled services may be cancelled',
        '• No refunds for unused membership time',
        '• Outstanding balances become immediately due',
        '• Sections that by nature should survive will continue (liability, indemnification, arbitration)'
      ]
    },
    {
      title: '18. Intellectual Property',
      content: [
        'All content, trademarks, logos, and intellectual property on the HSP platform are owned by HammerSawPaint or our licensors. You may not:',
        '• Copy, modify, or create derivative works',
        '• Use our trademarks without written permission',
        '• Remove copyright or proprietary notices',
        '• Reverse engineer our technology',
        'You retain ownership of feedback and content you provide, but grant us a license to use it for improving our services.'
      ]
    },
    {
      title: '19. General Provisions',
      content: [
        '19.1 Governing Law',
        'These Terms are governed by California law without regard to conflict of law principles.',
        '19.2 Severability',
        'If any provision is found unenforceable, the remaining provisions continue in full effect.',
        '19.3 No Waiver',
        'Our failure to enforce any right does not waive that right.',
        '19.4 Assignment',
        'You may not assign these Terms. We may assign our rights and obligations.',
        '19.5 Entire Agreement',
        'These Terms, along with our Privacy Policy, constitute the entire agreement between you and HSP.',
        '19.6 Force Majeure',
        'HSP is not liable for delays or failures due to circumstances beyond our reasonable control.',
        '19.7 Notices',
        'We may provide notices via email, platform messaging, or postal mail to your address on file.'
      ]
    },
    {
      title: '20. Contact Information',
      content: [
        'For questions about these Terms, contact:',
        'HammerSawPaint',
        'Email: support@hsppro.com',
        'Phone: (888) 504-6944',
        'Website: www.hsppro.com',
        'Mailing Address: [Your business address]'
      ]
    }
  ],

  footer: {
    acknowledgment: 'By using HammerSawPaint\'s services, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.',
    lastUpdated: 'Last Updated: October 22, 2025'
  }
};
